<template>
  <div class="t-ColorPicker">
    <label class="t-ColorPicker-label">{{ label }}</label>
    <div class="t-ColorPicker-inputs">
      <InputColor
        @click="showColorPicker"
        :value="value"
        @setColor="setColor"
        :hasError="hasError"
      />
      <InputTextColor
        :value="value"
        @setColor="setColor"
        :hasError="errorMessage"
      />
      <Popup v-if="isPopupOpen" @close="toggleColorPicker">
        <ModalSelectColor
          @setColor="setColor"
          :defaultColor="defaultColor"
          :resetLabel="resetLabel"
        />
      </Popup>
    </div>
  </div>
</template>

<script>
import InputColor from './InputColor.vue';
import InputTextColor from './InputTextColor.vue';
import ModalSelectColor from './ModalSelectColor.vue';
import Popup from '../Popup/Popup.vue';

export default {
  components: {
    InputColor, InputTextColor, Popup, ModalSelectColor,
  },
  props: {
    defaultColor: String,
    resetLabel: {
      type: String,
      default: 'Redefinir',
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isPopupOpen: false,
    };
  },
  computed: {
    hasError() {
      if (this.errorMessage !== '') {
        return true;
      }
      return false;
    },
  },
  methods: {
    showColorPicker() {
      this.isPopupOpen = true;
    },
    toggleColorPicker(value) {
      this.isPopupOpen = value;
    },
    setColor(color) {
      this.$emit('input', color);
    },
  },
};
</script>

<style scoped>
.t-ColorPicker {
  position: relative;
  width: 225px;
  height: 61px;
}
.t-ColorPicker-inputs {
  display: flex;
  align-items: center;
  margin-top: var(--track-spacing-sm);
}
.t-ColorPicker-label {
  width: 83px;
  height: 12px;
  font-family: var(--track-font-family-base);
  font-weight: var(--track-font-weight-medium);
  font-size: var(--track-font-size-xs);
  line-height: 12px;
  color: var(--track-color-bluegray-80);
}
</style>
